export const Controltype = {
  Slider: 'slider',
  RangeSlider: 'range_slider',
  Radio: 'radio',
  Radio_Image: 'radio_image',
  Dropdown: 'dropdown',
  Checkbox: 'checkbox'
}

export const Templates = {
  Template01: 'Template01',
  Template02: 'Template02',
  Template03: 'Template03',
  Template05: 'Template05',
  Template06: 'Template06'
}
export const Filters = {
  Shape: 'Shape',
  Style: 'style',
  Carat: 'Carat',
  Price: 'Price',
  Color: 'Color',
  Clarity: 'Clarity',
  Cut: 'Cut',
  SortBy: 'sort_by'
}
